
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

import LazyImg from '@xt/www/components/lazyImg/index.vue'

import type { AccountGiftUIData } from '@xt/client/entities/my-v2/types.d'
import { EnumRegisterModalNames } from '@xt/client/enums/messageModalQueue'

@Observer
@Component({
  components: { LazyImg }
})
export default class ReceiveGift extends Vue {
  @Prop({ required: true }) item: AccountGiftUIData

  handleReceive() {
    this.$niceModal.show(EnumRegisterModalNames.Gift, {
      dataSource: this.item
    })
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
